import { GoogleAnalytics4Script } from "./google-analytics/GoogleAnalytics4";
import { RedditScript } from "./Reddit";

export const ThirdPartyTracking = () => (
  <>
    <GoogleAnalytics4Script />
    <RedditScript />
  </>
);
